/* Italian Secret, 2026-09-28: Liquid product/configuration adapter for Andrea's sample campaign. */
(() => {
  'use strict';
  const el = document.getElementById('italiansecret-sample-config');
  const settings = JSON.parse(el.textContent);
  const config = window.PIZZA_CONFIG = {
    managedCampaign: Boolean(settings.managedCampaignUrl),
    publicId: null,
    conditionsVersion: '2026-09-21',
    conditionsText: null,
    addressSearchEnabled: settings.addressSearchEnabled !== false,
    previewMode: settings.previewMode === true,
    webhookUrls: settings.webhookUrls.filter(Boolean),
    submitUrl: settings.submitUrl,
    quoteUrl: settings.quoteUrl,
    campaignKey: settings.campaignKey,
    shopDomain: settings.shopDomain,
    cartRoot: settings.cartRoot,
    currency: settings.currency,
    deliveryMode: 'included',
    sampleDeliveryPence: 495,
    dropPackCapacity: 10,
    dropEnabled: settings.dropEnabled,
    timeZone: 'Europe/London',
    samples: settings.samples,
    products: [...new Map(settings.products.map(p => [p.variantId, p])).values()]
  };
  // Managed campaign identity is retained; old theme products/webhooks never override it.
  window.PizzaConfigReady = (async () => {
    if (!config.managedCampaign) return config;
    const campaignUrl = new URL(settings.managedCampaignUrl);
    const match = campaignUrl.pathname.match(/^\/public\/sample-campaigns\/([A-Za-z0-9_-]{32})\/widget$/);
    if (campaignUrl.protocol !== 'https:' || campaignUrl.username || campaignUrl.password || !match) throw Error('The sample campaign is not configured correctly.');
    const publicId = match[1];
    const response = await fetch('/apps/prometheus-subscriptions/sample-campaign/config?' + new URLSearchParams({publicId}), {
      credentials: 'same-origin', headers: {Accept:'application/json'}, signal: AbortSignal.timeout(15000)
    });
    if (!response.ok) throw Error('The sample offer could not be loaded. Please retry.');
    const result = await response.json(), campaign = result.campaign;
    if (!campaign || campaign.publicId !== publicId || campaign.sampleQuantity !== 2 ||
        !Array.isArray(result.samples) || !result.samples.length || !Array.isArray(result.extras) ||
        !Array.isArray(campaign.shippingCountries) || !campaign.shippingCountries.length ||
        !Array.isArray(campaign.callbackWindows) || !campaign.callbackWindows.length ||
        !campaign.conditionsVersion || !campaign.conditionsText || !campaign.currency) throw Error('The sample offer settings could not be confirmed.');
    new Intl.DateTimeFormat('en', {timeZone:campaign.callbackTimeZone});
    const product = row => {
      if (!/^\d+$/.test(String(row.variantId)) || typeof row.available !== 'boolean') throw Error('The sample catalogue could not be confirmed.');
      return {id:String(row.variantId), variantId:String(row.variantId), sku:row.sku, name:row.title || row.sku,
        image:row.imageUrl || settings.fallbackProductImage || '', description:'', available:row.available, pricePence:null};
    };
    // Added by Italian Secret on 2026-10-08, PD-1304: present samples in the section's configured
    // order ("Free sample A" then "Free sample B" settings), matched by variant id; never by SKU.
    const sampleOrder = (settings.samples || []).map(row => String(row.variantId));
    const rank = row => { const i = sampleOrder.indexOf(String(row.variantId)); return i < 0 ? sampleOrder.length : i; };
    result.samples = result.samples.map((row, i) => [row, i]).sort((a, b) => rank(a[0]) - rank(b[0]) || a[1] - b[1]).map(pair => pair[0]);
    Object.assign(config, {publicId, previewMode:false, webhookUrls:[], dropEnabled:true,
      quoteUrl:'/apps/prometheus-subscriptions/sample-campaign/quote', submitUrl:'/apps/prometheus-subscriptions/sample-campaign/requests',
      currency:campaign.currency, timeZone:campaign.callbackTimeZone, shippingCountries:campaign.shippingCountries,
      callbackWindows:campaign.callbackWindows, conditionsVersion:campaign.conditionsVersion, conditionsText:campaign.conditionsText,
      samples:result.samples.map(product), products:result.extras.map(product)});
    return config;
  })();
  // A rejected load is handled by the wizard; prevent an early unhandled rejection.
  window.PizzaConfigReady.catch(() => {});
})();

/* Stable, date-seeded timing for the labelled ESTIMATE, never actual claim data.
 * Everyone with the same UK date/time gets the same answer. No Math.random, cookies,
 * visitor state or storage. Capacity is 10 sample packs; morning estimate is 10.
 * Eight non-overlapping windows each remove one two-pizza pack; last threshold is <= 23:00.
 * Live stock from the API overrides this estimate. */
window.PizzaStockEstimate = function(now, timeZone = 'Europe/London') {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
    timeZone, year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'
  }).formatToParts(now).map(p => [p.type,p.value]));
  const key = `${parts.year}-${parts.month}-${parts.day}`;
  let seed = 2166136261;
  for (const char of key) seed = Math.imul(seed ^ char.charCodeAt(0),16777619) >>> 0;
  const minute = Number(parts.hour)*60+Number(parts.minute);
  const windows = [[690,735],[750,775],[785,810],[820,845],[850,890],[990,1050],[1170,1230],[1320,1380]];
  let remaining = 10;
  windows.forEach(([start,end],index) => {
    let hash = Math.imul(seed ^ (index+1),2246822519) >>> 0;
    hash = (hash ^ (hash >>> 13)) >>> 0;
    const threshold = start + hash % (end-start+1);
    if (minute >= threshold) remaining -= 1;
  });
  return remaining;
};
